var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isRouterAlive)?_c('RouterView',{staticClass:"app",attrs:{"id":"app"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }